import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useRoleOptions = () => {
  const {
    data: roleOptions,
    isLoading: isRoleOptionsLoading,
    refetch: refetchRoleOptions,
  } = useQuery({
    queryKey: ["roleOptions"],
    queryFn: () => dropdownService.getRoleOptions(),
  });

  return {
    roleOptions: roleOptions || [],
    isRoleOptionsLoading,
    refetchRoleOptions,
  };
};
